import { Typography } from 'antd';

import { getAssetTypeConfig } from '@/shared/api/openmetadata/constants';
import { convertFqnToPath } from '@/shared/lib/format';
import type { RecentAsset } from '@/shared/types/recentAssets';
import { Icon } from '@/shared/ui/Icon';

import styles from './SearchResultRecent.module.css';

const { Text } = Typography;

type SearchResultRecentProps = {
  recentAssets: RecentAsset[];
  onClickRecentAsset: (asset: RecentAsset) => void;
};

export const SearchResultRecent = ({ recentAssets, onClickRecentAsset }: SearchResultRecentProps) => {
  return (
    <>
      <Text className={styles.sectionTitle}>최근 본 자산</Text>
      <div className={styles.list}>
        {recentAssets.map((item) => {
          const assetTypeConfig = getAssetTypeConfig(item.type);
          const backgroundColor = assetTypeConfig.tagBackgroundColor || 'var(--opds-glo-palette-gray-98)';
          const borderColor = assetTypeConfig.tagBackgroundColor || 'var(--opds-glo-palette-gray-90)';
          const iconColor = assetTypeConfig.color || 'var(--opds-glo-palette-gray-50)';

          const iconWrapperStyle = {
            backgroundColor,
            border: `1px solid ${borderColor}`,
          };

          const isRun = item.type === 'run';
          let displayPath: string;
          if (isRun && item.experimentName) {
            displayPath = `Experiments / ${item.experimentName}`;
          } else {
            const fullPath = convertFqnToPath(item.fqn);
            const parts = fullPath.split(' / ');
            displayPath = parts.length > 1 ? parts.slice(0, -1).join(' / ') : fullPath;
          }

          return (
            <div key={item.id} className={styles.listItem} onClick={() => onClickRecentAsset(item)}>
              <div className={styles.iconWrapper} style={iconWrapperStyle}>
                <Icon assetType={item.type} size={13} color={iconColor} />
              </div>
              <div className={styles.itemInfo}>
                <span className={styles.itemPath}>{displayPath}</span>
                <span className={styles.itemName}>{item.name}</span>
              </div>
            </div>
          );
        })}
      </div>
    </>
  );
};
